import { render } from "./FrmKiloRecord.vue?vue&type=template&id=214bd1b1&scoped=true"
import script from "./FrmKiloRecord.vue?vue&type=script&lang=js"
export * from "./FrmKiloRecord.vue?vue&type=script&lang=js"

import "./FrmKiloRecord.vue?vue&type=style&index=0&id=214bd1b1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214bd1b1"]])

export default __exports__